var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 48,
    viewBox: "0 0 62 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8955 18.1016C28.4938 19.4016 33.5055 19.4016 38.1038 18.1016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.4521 4H18.5488C13.0463 4 8.57715 7.48 8.57715 11.72V39.9C8.57715 43.5 11.9096 45.02 15.9913 43.28L28.598 37.86C29.9413 37.28 32.1113 37.28 33.4288 37.86L46.0355 43.28C50.1171 45.04 53.4496 43.52 53.4496 39.9V11.72C53.4238 7.48 48.9546 4 43.4521 4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.4521 4H18.5488C13.0463 4 8.57715 7.48 8.57715 11.72V39.9C8.57715 43.5 11.9096 45.02 15.9913 43.28L28.598 37.86C29.9413 37.28 32.1113 37.28 33.4288 37.86L46.0355 43.28C50.1171 45.04 53.4496 43.52 53.4496 39.9V11.72C53.4238 7.48 48.9546 4 43.4521 4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.b6e35bd9c47b55021ec74111f7ec5af6.svg";
export { ForwardRef as ReactComponent };